module.exports = __webpack_public_path__ + "img/prodia-warsztat.74ebd26e.jpg";